import type {timezoneMessages} from 'src/public/timezoneMessages/timezoneMessages';
import type {LocaleData} from 'src/types';

type TimeZoneDescriptor = (typeof timezoneMessages)[string];

export default function getTimeZoneMessageValue(
  localeData: LocaleData,
  descriptor: TimeZoneDescriptor,
): string {
  return localeData.messages[descriptor.id] ?? descriptor.defaultMessage;
}
